export const MAX_MASTER_GAIN_DB = 24 as const;
export const PEAK_CEILING_DBFS = -1 as const;
export const LIMITER_LOOKAHEAD_MS = 2 as const;

export function dbToLinear(db: number): number {
  return Math.pow(10, db / 20);
}

export function linearToDb(x: number): number {
  return x > 0 ? 20 * Math.log10(x) : -Infinity;
}

export function clampMasterGainDb(db: number): number {
  if (!Number.isFinite(db)) return 0;
  return Math.max(0, Math.min(MAX_MASTER_GAIN_DB, db));
}
